import { GAME_CONFIG } from "./config";

/**
 * Calcula el grosor de fuente apropiado basado en el tamaño del tablero
 * @param {number} gridSize - Tamaño del tablero (número de casillas por fila/columna)
 * @returns {number} Valor de font-weight (100-900)
 */
export function calculateFontWeight(gridSize) {
  const config = GAME_CONFIG.LETTER_FONT_WEIGHT;

  const clampedGridSize = Math.max(
    config.MIN_GRID_SIZE,
    Math.min(config.MAX_GRID_SIZE, gridSize)
  );


  const normalizedSize = (clampedGridSize - config.MIN_GRID_SIZE) /
    (config.MAX_GRID_SIZE - config.MIN_GRID_SIZE);

  const invertedNormalized = 1 - normalizedSize;

  const fontWeight = config.MIN_WEIGHT +
    (invertedNormalized * (config.MAX_WEIGHT - config.MIN_WEIGHT));

  return Math.round(fontWeight / 100) * 100;
}

/**
 * Aplica el grosor de fuente calculado al elemento del grid
 * @param {HTMLElement} gridElement - Elemento del grid donde aplicar la variable CSS
 * @param {number} gridSize - Tamaño del tablero
 */
export function applyFontWeight(gridElement, gridSize) {
  if (!gridElement) return;

  const fontWeight = calculateFontWeight(gridSize);
  gridElement.style.setProperty('--letter-font-weight', fontWeight);
}
